import { render, staticRenderFns } from "./MapIconRestoraunt.vue?vue&type=template&id=3fdd8c76&scoped=true&"
import script from "./MapIconRestoraunt.vue?vue&type=script&lang=js&"
export * from "./MapIconRestoraunt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd8c76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fdd8c76')) {
      api.createRecord('3fdd8c76', component.options)
    } else {
      api.reload('3fdd8c76', component.options)
    }
    module.hot.accept("./MapIconRestoraunt.vue?vue&type=template&id=3fdd8c76&scoped=true&", function () {
      api.rerender('3fdd8c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconRestoraunt.vue"
export default component.exports